import type { FC } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { InfoTooltip } from "app/components/React/Tooltip/InfoTooltip/InfoTooltip";
import { translate } from "app/filters/i18nFilter";

import {
    XAxisContainer,
    XAxisTooltipContainer,
    YAxisContainer,
    YAxisContent,
    YAxisTooltipContainer,
} from "./styledComponents";

const { carbon } = colorsPalettes;

interface IAxisLabelProps {
    title: string;
    tooltip: string;
}
export const YAxisLabel: FC<IAxisLabelProps> = ({ title, tooltip }) => (
    <YAxisContainer>
        <InfoTooltip
            infoText={translate(tooltip)}
            infoIconContainer={YAxisTooltipContainer}
        />
        <YAxisContent
            fontVariant="caption"
            color={carbon[400]}
        >
            {translate(title)}
        </YAxisContent>
    </YAxisContainer>
);

export const XAxisLabel: FC<IAxisLabelProps> = ({ title, tooltip }) => (
    <XAxisContainer>
        <Text
            fontVariant="caption"
            color={carbon[400]}
        >
            {translate(title)}
        </Text>
        <InfoTooltip
            infoText={translate(tooltip)}
            infoIconContainer={XAxisTooltipContainer}
        />
    </XAxisContainer>
);
